export const isValidForm = values => {
  if (!values?.dataAbertura?.dataInicio || !values?.dataAbertura?.dataFim) {
    return false;
  }

  return true;
};
